import { render, staticRenderFns } from "./DevPagination.vue?vue&type=template&id=366c4fa2"
import script from "./DevPagination.vue?vue&type=script&lang=js"
export * from "./DevPagination.vue?vue&type=script&lang=js"
import style0 from "./DevPagination.vue?vue&type=style&index=0&id=366c4fa2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports